import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { useFrozenCustomerTabBreadcrumbs } from "Helpers/useFrozenClientBreadcrumbs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Client  } from "assets/SideBarIcons/customer.svg";
import CustomerTabs from "./CustomerTabs";
import { Box } from "@mui/material";
import PaymentListing from "pages/Payment/PaymentListing";
export default function CustomerPayments() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const breadcrumbItems = useFrozenCustomerTabBreadcrumbs("payments");
    return (<>
        <ComponentHeaderTwo
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate('/clients')}
            onSubmit={() => {}}
            heading={t('customer') + ' (' + t('Individual') + ')'}
            icon={<Client height={28} width={28} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={false}
            breadcrumbItems={breadcrumbItems}
        />
        <Box className={`flex`}>
            <CustomerTabs params={params} selectedIndex={4} />
            <Box className='mt-[10px] w-[100%]'>
                <PaymentListing userId={+(params as any)?.id} type='customer' />
            </Box>
        </Box>
    </>)
}
